{
  "version": 1,
  "asset_id": "51c5c354-70bf-4649-958c-c8804a1a4885",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/51c5c354-70bf-4649-958c-c8804a1a4885/publications-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/51c5c354-70bf-4649-958c-c8804a1a4885/publications-card.webp",
  "original_filename": "publications-card.webp",
  "size": 9428,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:20Z"
}
